import { render, staticRenderFns } from "./CadastrarEditarOrganogramaDialog.vue?vue&type=template&id=2f7afcf8"
import script from "./CadastrarEditarOrganogramaDialog.vue?vue&type=script&lang=js"
export * from "./CadastrarEditarOrganogramaDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports